const dependencies = [
  '$scope', 'ClientSite', 'ClientLocation', 'EntityManager', 'clientSiteStatus', 'pluralizeService'
];

const ManagerClientSitesController = function(
  $scope, ClientSite, ClientLocation, EntityManager, clientSiteStatus, pluralizeService
) {

  const vm = this;

  vm.isShownSitePopup = false;
  vm.isShownClockInPopup = false;
  vm.ascendingNameOrder = true;
  vm.pluralizeService = pluralizeService;
  vm.clientSiteStatus = clientSiteStatus;

  let toggledSite;

  const entityManager = new EntityManager(ClientSite, {
    params: {
      clientId: $scope.managerClientLayoutCtrl.clientId
    }
  });

  vm.$onInit = function() {
    initClient();
    entityManager.loadAll();
  };

  vm.showSitePopup = function(site) {
    vm.popupSite = site || entityManager.createEntity();
    vm.isShownSitePopup = true;
  };

  vm.closeSitePopup = function(savedSite) {
    vm.isShownSitePopup = false;
    if (savedSite) {
      vm.client.sitesCount++;
      entityManager.updateEntity(savedSite);
    }
  };

  vm.toggleNameOrder = () => vm.ascendingNameOrder = !vm.ascendingNameOrder;

  vm.getSites = () => entityManager.entities;

  vm.isActiveSite = function(site) {
    return clientSiteStatus.isActive(site.status);
  };

  vm.removeSite = function (site) {
    entityManager.removeEntity(site, () => vm.client.sitesCount--);
  };

  vm.areShownSiteLocations = function(site) {
    return toggledSite === site;
  };

  vm.toggleSiteLocations = function(site) {
    if (vm.areShownSiteLocations(site)) {
      toggledSite = null;
    } else {
      toggledSite = site;
    }
  };

  vm.showClockInPopup = function() {
    vm.isShownClockInPopup = true;
  };

  vm.closeClockInPopup = function() {
    vm.isShownClockInPopup = false;
  };

  vm.onMobileClockInChange = function(value) {
    vm.client.enableMobileClockIn = value;
    vm.client.save();
  };

  vm.onDesktopClockInChange = function(value) {
    vm.client.enableDesktopClockIn = value;
    vm.client.save();
  };

  vm.onLocationRemove = function(location) {
    _.each(vm.getSites(), function(site) {
      const foundLocation = _.find(site.locations, function(siteLocation) {
        return siteLocation.id === location.id;
      });
      if (foundLocation) {
        site.locations = _.without(site.locations, foundLocation);
      }
    });
    new ClientLocation(location).remove();
  };

  vm.onLocationRemoveFromSite = function(location) {
    toggledSite.locations = _.without(toggledSite.locations, location);
    toggledSite.save();
  };

  vm.onLocationUpdate = function(location) {
    _.each(vm.getSites(), function(site) {
      const foundLocation = _.find(site.locations, function(siteLocation) {
        return siteLocation.id === location.id;
      });
      if (foundLocation) {
        angular.copy(location, foundLocation);
      } else if (vm.areShownSiteLocations(site)) {
        site.locations.push(location);
        site.save();
      }
    });
  };

  const initClient = function() {
    $scope.managerClientLayoutCtrl.loadClient().then(client => vm.client = client);
  };

  return vm;

};

angular.module('public.client-manager.client')
  .controller('ManagerClientSitesController', dependencies.concat(ManagerClientSitesController));
